export default __webpack_public_path__ + "static/media/triangle-up.0e65d8cc.svg";